import constants from '../constants';
import trackEvent from './track-event';

const { events } = constants;

const trackPageManagerSearchPerformed = ({ searchTerm, searchResults }) => {
  if (!searchTerm.trim()) return;

  const traits = {
    searchTerm,
    searchResults,
  };

  trackEvent(events.PAGE_MANAGER_SEARCH_PERFORMED, traits);
};

export default trackPageManagerSearchPerformed;
